/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_About_PhotoInputs */

const en_label_about_photo = /** @type {(inputs: Label_About_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company Photo`)
};

const es_label_about_photo = /** @type {(inputs: Label_About_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto de la Empresa`)
};

const fr_label_about_photo = /** @type {(inputs: Label_About_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photo de l'entreprise`)
};

const de_label_about_photo = /** @type {(inputs: Label_About_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmensfoto`)
};

const id_label_about_photo = /** @type {(inputs: Label_About_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto Perusahaan`)
};

/** @type {(inputs: Label_About_PhotoInputs) => LocalizedString} */
const ja_label_about_photo = en_label_about_photo;

/** @type {(inputs: Label_About_PhotoInputs) => LocalizedString} */
const zh_label_about_photo = en_label_about_photo;

/** @type {(inputs: Label_About_PhotoInputs) => LocalizedString} */
const ar_label_about_photo = en_label_about_photo;

/** @type {(inputs: Label_About_PhotoInputs) => LocalizedString} */
const it_label_about_photo = en_label_about_photo;

/** @type {(inputs: Label_About_PhotoInputs) => LocalizedString} */
const ru_label_about_photo = en_label_about_photo;

/** @type {(inputs: Label_About_PhotoInputs) => LocalizedString} */
const pt_label_about_photo = en_label_about_photo;

/** @type {(inputs: Label_About_PhotoInputs) => LocalizedString} */
const ko_label_about_photo = en_label_about_photo;

/**
* | output |
* | --- |
* | "Company Photo" |
*
* @param {Label_About_PhotoInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const label_about_photo = /** @type {((inputs?: Label_About_PhotoInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_About_PhotoInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_label_about_photo(inputs)
	if (locale === "es") return es_label_about_photo(inputs)
	if (locale === "fr") return fr_label_about_photo(inputs)
	if (locale === "de") return de_label_about_photo(inputs)
	if (locale === "ja") return ja_label_about_photo(inputs)
	if (locale === "zh") return zh_label_about_photo(inputs)
	if (locale === "ar") return ar_label_about_photo(inputs)
	if (locale === "id") return id_label_about_photo(inputs)
	if (locale === "it") return it_label_about_photo(inputs)
	if (locale === "ru") return ru_label_about_photo(inputs)
	if (locale === "pt") return pt_label_about_photo(inputs)
	return ko_label_about_photo(inputs)
});